const init = () => {
    
    const dataLayer = window.dataLayer || [];
    
    // Cookie utility functions
    function setCookie(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    }
    
    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    // Cache for loaded videos to prevent reloading
    const videoCache = {
        mobile: null,
        desktop: null
    };

    document.addEventListener('DOMContentLoaded', function() {
        let shouldHideTakeover = false;


        if (window.location.hostname.includes('penguin.co.nz') || window.location.pathname.includes('alchemised')) {
            shouldHideTakeover = true;
        }
        
        // Load appropriate video based on viewport size
        const videoElement = document.querySelector('.takeover-video');
        if (videoElement) {
            const isMobileViewport = window.innerWidth <= 768;
            const videoType = isMobileViewport ? 'mobile' : 'desktop';
            const videoSrc = isMobileViewport ? 'https://stream.mux.com/TG78YyvJscuj22qS00B19PW8IwxIdlZ4s3rA9n02Dtiu00/capped-1080p.mp4' : 'https://stream.mux.com/01UnXwlwEaa012je493cw3qK3s01TLUZfc00BnMJUhQvtBE/capped-1080p.mp4';
            
            // Check if video is already cached
            if (videoCache[videoType]) {
                videoElement.src = videoCache[videoType];
            } else {
                videoElement.src = videoSrc;
                videoCache[videoType] = videoSrc;
            }
            
            videoElement.classList.add(videoType);
            
            // iOS-specific video handling
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            if (isIOS) {
                // iOS requires user interaction to start video playback
                videoElement.addEventListener('loadeddata', function() {
                    videoElement.play().catch(function(error) {
                        console.log('Video autoplay failed:', error);
                    });
                });
                
                // Handle video loading errors
                videoElement.addEventListener('error', function(e) {
                    console.log('Video loading error:', e);
                });
            }
        }
        
        document.body.classList.add("hidden");
        if (getCookie("penguin-au.takeoverClosed") === "true" || shouldHideTakeover) {
            document.body.classList.remove("hidden");
        } else {
            document.querySelector(".takeover-wrapper").classList.remove("inactive");
            dataLayer.push({
                event: 'site_takeover_interaction',
                action: 'viewed',
                url: window.location.href,
            });
        }
    });

    document.querySelector(".takeover-video-wrapper").addEventListener("click", (e) => {
        e.preventDefault();
        setCookie("penguin-au.takeoverClosed", "true", 7);
        dataLayer.push({
            event: 'site_takeover_interaction',
            action: 'video_clicked',
            url: window.location.href,
        })

        setTimeout(() => {
            window.location.href = "https://www.penguin.com.au/books/alchemised-9780241714331?utm_source=Website&utm_medium=VideoPop";
        }, 200);
    });

    document.getElementById("closeTakeover").addEventListener("click", () => {
        gsap.to(".takeover-wrapper", { opacity: 0, duration: 0.5, onComplete: () => {
            setCookie("penguin-au.takeoverClosed", "true", 1);
            dataLayer.push({
                event: 'site_takeover_interaction',
                action: 'closed',
                url: window.location.href,
            });
            document.querySelector(".takeover-wrapper").style.display = "none";
            document.body.classList.remove("hidden");
        }});
    });

    document.getElementById("takeoverOverlay").addEventListener("click", () => {
        gsap.to(".takeover-wrapper", { opacity: 0, duration: 0.5, onComplete: () => {
            setCookie("penguin-au.takeoverClosed", "true", 1);
            dataLayer.push({
                event: 'site_takeover_interaction',
                action: 'closed',
                url: window.location.href,
            });
            document.querySelector(".takeover-wrapper").style.display = "none";
            document.body.classList.remove("hidden");
        }});
    });

    document.querySelector(".skip").addEventListener("click", (e) => {
        e.preventDefault();
        gsap.to(".takeover-wrapper", { opacity: 0, duration: 0.5, onComplete: () => {
            setCookie("penguin-au.takeoverClosed", "true", 1);
            dataLayer.push({
                event: 'site_takeover_interaction',
                action: 'skipped',
                url: window.location.href,
            });
            document.querySelector(".takeover-wrapper").style.display = "none";
            document.body.classList.remove("hidden");
        }});
    });


    // Debounce resize handler to prevent multiple video loads
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            const videoElement = document.querySelector('.takeover-video');
            if (videoElement) {
                const isMobileViewport = window.innerWidth <= 768;
                const currentClass = videoElement.classList.contains('mobile') ? 'mobile' : 'desktop';
                const shouldBeMobile = isMobileViewport;
                const videoType = isMobileViewport ? 'mobile' : 'desktop';
                
                // Only switch if the viewport type has changed
                if ((shouldBeMobile && currentClass === 'desktop') || (!shouldBeMobile && currentClass === 'mobile')) {
                    const videoSrc = isMobileViewport ? 'https://stream.mux.com/TG78YyvJscuj22qS00B19PW8IwxIdlZ4s3rA9n02Dtiu00/capped-1080p.mp4' : 'https://stream.mux.com/01UnXwlwEaa012je493cw3qK3s01TLUZfc00BnMJUhQvtBE/capped-1080p.mp4';
                    
                    // Check cache first, only load if not cached
                    if (videoCache[videoType]) {
                        videoElement.src = videoCache[videoType];
                    } else {
                        videoElement.src = videoSrc;
                        videoCache[videoType] = videoSrc;
                    }
                    
                    // Update classes
                    videoElement.classList.remove('mobile', 'desktop');
                    videoElement.classList.add(videoType);
                    
                    // iOS-specific video handling for resize
                    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                    if (isIOS) {
                        videoElement.addEventListener('loadeddata', function() {
                            videoElement.play().catch(function(error) {
                                console.log('Video autoplay failed on resize:', error);
                            });
                        });
                    }
                }
            }
        }, 250); // Wait 250ms after resize stops
    });
};

export default init;